import React, { useEffect, useState } from 'react';
import Sidebar from '../../../sideBar';
import AssignmentHistory from './assignmentHistory';

const TaskDetails = ({ changeActiveCourse }) => {
    // Add this effect to fix pointer events issues on this page
    useEffect(() => {
        const fixPointerEvents = () => {
            // Remove any overlay that might be blocking interactions
            const overlay = document.querySelector('[style*="z-index: 4"]');
            if (overlay) {
                overlay.style.pointerEvents = 'none';
            }

            // Ensure the main content has proper pointer events
            const mainContent = document.querySelector('.page-right-section');
            if (mainContent) {
                mainContent.style.pointerEvents = 'auto';
                mainContent.style.position = 'relative';
                mainContent.style.zIndex = '5';
            }

            // Fix all interactive elements
            const interactiveElements = document.querySelectorAll('a, button, .btn, .table');
            interactiveElements.forEach(el => {
                el.style.position = 'relative';
                el.style.zIndex = '10';
                el.style.pointerEvents = 'auto';
            });

            // Specifically target the "Go back" button
            const goBackButton = document.querySelector('.page-header-product-left a');
            if (goBackButton) {
                goBackButton.style.position = 'relative';
                goBackButton.style.zIndex = '20';
                goBackButton.style.pointerEvents = 'auto';
            }
        };

        // Run immediately and after a short delay to ensure it applies after any animations
        fixPointerEvents();
        setTimeout(fixPointerEvents, 300);
    }, []);

        const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };
      
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <section className="step-container align-stretch container">
            {isMobile ? <></> : <Sidebar />}
            <div className="page-right-section">
                <div className="" style={{ marginTop: '0px' }}>
                    <div className="db-body">
                        <div className="settingsContainer">
                            <div id="taskListContainer">
                                <div className="panel panel-default panel-body coach-table">
                                    <div className="page-header-product-left ">
                                        <a 
                                            target="_self" 
                                            href="mycourse"
                                            style={{ position: 'relative', zIndex: 20, pointerEvents: 'auto' }}
                                        >
                                            <i className="fa fa-repeat"></i> Go back
                                        </a>
                                    </div>
                                    <AssignmentHistory />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TaskDetails;